import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Title from '../../components/common/Title';
import { Topbar } from '../../components/include/Topbar';
import Sports from '../../components/Extracurricular/Sports';
import Arts from '../../components/Extracurricular/Arts';
import Clubs from '../../components/Extracurricular/Clubs';
import Leadership from '../../components/Extracurricular/Leadership';
import Religious from '../../components/Extracurricular/Religious';
import Volunteering from '../../components/Extracurricular/Volunteering';
import { useSelector } from 'react-redux';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';
import { useCountryNavigate } from '../../components/common/UseCountryNavigate';

const Extracurricular_main = () => {
  const [activeTab, setActiveTab] = useState("Sports");
  const location = useLocation();
  const tabs = ["Sports", "Arts", "Clubs", "Leadership", "Religious", "Volunteering"];
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const isAccessible = role === "admin" || role == "subadmin" || role == "schooladmin" || permissions && (permissions?.includes('view_Extracurricular') || permissions?.includes('view_School')) || false;
  const addPermission = role == "subadmin" || role == "schooladmin" || permissions && (permissions?.includes('edit_Extracurricular') || permissions?.includes('edit_School')) || false;
  const deletePermission = role == "subadmin" || role == "schooladmin" || permissions && (permissions?.includes('delete_Extracurricular') || permissions?.includes('delete_School')) || false;


  const handleAddButtonClick = () => {
    if (activeTab === "Sports") {
      navigate("extracurricular/sports/add");
    }
    else if (activeTab === "Arts") {
      navigate("extracurricular/arts/add");
    } else if (activeTab === "Clubs") {
      navigate("extracurricular/clubs/add");
    } else if (activeTab === "Leadership") {
      navigate("extracurricular/leadership/add");
    } else if (activeTab === "Religious") {
      navigate("extracurricular/religious/add");
    } else if (activeTab === "Volunteering") {
      navigate("extracurricular/volunteering/add");
    }
  };

  const getAddButtonLabel = () => {
    switch (activeTab) {
      case "Sports":
        return "+ Add Sports";
      case "Arts":
        return "+ Add Arts";
      case "Clubs":
        return "+ Add Clubs";
      case "Leadership":
        return "+ Add Leadership";
      case "Religious":
        return "+ Add Religious";
      case "Volunteering":
        return "+ Add Volunteering";
      default:
        return null;
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {

    if (location.state?.currentTab) {
      setActiveTab(location.state.currentTab);
    }
  }, [location.state]);

  if (!isAccessible) {
    return (
      <>
        <Error403Page />
      </>
    );
  }
  return (
    <>

      <Title name="Extracurricular" />
      <Topbar title="Extracurricular" />
      <div className="p-6 space-y-6 pr-0">
        {/* Tabs */}
        <div className="flex justify-between flex-wrap gap-y-2">
          <div className="flex gap-2 overflow-x-auto">
            {tabs?.map((tab) => (
              <button
                key={tab}
                className={`px-4 py-2 rounded-lg whitespace-nowrap ${activeTab === tab
                  ? "bg-secondary_main text-white"
                  : "bg-white text-black"
                  }`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="flex gap-2">
            {addPermission && <button
              className="bg-primary_main text-white px-4 py-2 rounded-lg whitespace-nowrap"
              // onClick={()=> navigate("/education/performance/add")}
              onClick={handleAddButtonClick}
            >
              {getAddButtonLabel()}
            </button>}

          </div>

        </div>

        {/* Conditional Tab Content */}
        {activeTab === "Sports" && (
          <>
            <Sports />
          </>
        )}

        {activeTab === "Arts" && (
          <>
            <Arts />
          </>
        )}

        {activeTab === "Clubs" && (
          <>
            <Clubs />
          </>
        )}

        {activeTab === "Leadership" && (
          <>
            <Leadership />
          </>
        )}
        {activeTab === "Religious" && (
          <>
            <Religious />
          </>
        )}
        {activeTab === "Volunteering" && (
          <>
            <Volunteering />
          </>
        )}
      </div>
    </>
  )
}

export default Extracurricular_main